'use client';

import { getTrackOrderList } from '@/api/order';
import { useStore } from '@/providers/app-store-provider';
import { useEffect, useState } from 'react';

export const useTrackOrderList = () => {
  const token = useStore((state) => state.token);

  const [orderListState, setOrderListState] = useState({
    orderList: [],
    loading: false,
    hasData: false,
    isLogin: !!token,
  });

  useEffect(() => {
    if (token) {
      fetchOrderList();
    }
    setOrderListState((prev) => ({
      ...prev,
      isLogin: !!token,
    }));
  }, [token]);

  const fetchOrderList = async () => {
    if (!token) {
      setOrderListState((prev) => ({
        ...prev,
        loading: false,
        hasData: false,
        isLogin: false,
      }));
      return;
    }

    setOrderListState((prev) => ({
      ...prev,
      loading: true,
    }));
    const { code, data } = await getTrackOrderList({ limit: 5, page: 1, track_order: 1 });

    if (code !== 200) {
      setOrderListState((prev) => ({
        ...prev,
        loading: false,
        hasData: false,
      }));
      return;
    }

    setOrderListState((prev) => ({
      ...prev,
      loading: false,
      hasData: true,
      orderList: data.data,
    }));
  };

  return { orderListState, fetchOrderList };
};
